import { Config } from '@backstage/config';
import { IdentityApi } from '@backstage/core-plugin-api';
import {
  EnvironmentConfigProviderApi,
  environmentConfigProviderResponse,
} from './EnvironmentConfigProviderApi';
import { FeatureFlagResult } from './types';

const getJson = async <T,>(response: Response): Promise<T> =>
  (await response.json()) as T;

export class EnvironmentConfigProviderClient
  implements EnvironmentConfigProviderApi
{
  private readonly identity: IdentityApi;
  private readonly backendBaseUrl: string;

  constructor(config: Config, identity: IdentityApi) {
    this.backendBaseUrl = config.get('backend.baseUrl');
    this.identity = identity;
  }

  async fetchFeatureFlag(
    key: string,
  ): Promise<environmentConfigProviderResponse<FeatureFlagResult>> {
    const { token } = await this.identity.getCredentials();
    const payload = {
      type: 'boolean',
      key: `featureFlag.${key}`,
    };

    const response = await fetch(
      `${this.backendBaseUrl}/api/environmentConfigProvider`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(payload),
      },
    );

    return {
      response,
      json: () => getJson<FeatureFlagResult>(response),
    };
  }
}
